
import { 
    AppEnum, 
    FaBuilding, 
    FaCalendar, 
    FaDollarSign, 
    FaHashtag, 
    FaUserTag, 
    Header, 
    MatchingEnums,
    OptionHelper,
    RecordMap
} from "@/Shared";

import  {  CityModel, SectorModel } from '@/Domains';
import { MatchingViewModel } from "./ViewModels";

export type SelectOption = {
    value: any,
    label: any
}

export class MatchingHeader {

    private constructor() { }

    get id() {
        return {
            key: 'id',
            icon: <FaHashtag />,
            label: 'ID',
            type: 'number',
            isSortable: true
        }
    }

    get needId() {
        return {
            key: 'needId',
            icon: <FaHashtag />,
            label: 'N° Besoin',
            type: 'number',
            isSortable: true
        }
    }

    get propertyId() {
        return {
            key: 'propertyId',
            icon: <FaBuilding />,
            label: 'N° Bien',
            type: 'number',
            isSortable: true
        }
    }

    getOperationType(oprationTypes: AppEnum[]) {
        return {
            key: 'operationType',
            icon: <FaUserTag />,
            label: 'Opération',
            type: 'string',
            isSortable: true,
            filter: {
                label: "Opération",
                options: oprationTypes,
                case: 'sensitive'
            }
        }
    }

    getType(types: AppEnum[]) {
        return {
            key: 'propertyType',
            icon: <FaUserTag />,
            label: 'Type de bien',
            type: 'string',
            isSortable: true,
            filter: {
                label: "Type",
                options: types,
                case: 'sensitive'
            }
        }
    }

    getCategory(categoryTypes: AppEnum[]) {
        return {
            key: 'propertyCategory',
            icon: <FaUserTag />,
            label: 'Catégorie de bien',
            type: 'string',
            isSortable: true,
            isHidden: true,
            filter: {
                label: "Catégorie",
                options: categoryTypes,
                case: 'sensitive'
            }
        }
    }


    getSector(sectorMap: RecordMap<SectorModel>) {
        return {
            key: 'sectorName',
            icon: <FaUserTag />,
            label: 'Secteur',
            type: 'string',
            isSortable: true,
            filter: {
                label: "Localisation",
                options: OptionHelper.sectorOptions(sectorMap.toArray()),
                case: 'sensitive'
            }
        }
    }

    getPriceRange(priceRangeEnums: AppEnum[]) {
       
        return {
            key: 'priceRangeLabel',
            icon: <FaDollarSign />,
            label: 'Budget',
            type: 'number',
            isSortable: true,
            filter: {
                label: "Budget",
                options: OptionHelper.sortByLabel(priceRangeEnums),
                case: 'sensitive'
            }
        }
    }

    getCity(cityMap: RecordMap<CityModel>) {
        return {
            key: 'cityName',
            icon: <FaUserTag />,
            label: 'Ville',
            type: 'string',
            isSortable: true,
            /*
            filter: {
                label: "Ville",
                options: cityEnums,
                case: 'sensitive'
            }*/
        }
    }


    get createdAt() {
        return {
            key: 'createdAt',
            icon: <FaCalendar />,
            label: 'Date',
            type: 'string',
            isSortable: true
        }
    }

    getStatus(statuses: AppEnum[]) {
        return {
            key: 'status',
            icon: <FaUserTag />,
            label: 'Statut',
            type: 'string',
            isSortable: true,
            filter: {
                label: "Selon Résultat",
                options: statuses,
                case: 'sensitive'
            }
        }
    }

    getContact() {
        return {
            key: 'contactName',
            icon: <FaUserTag />,
            label: 'Contact',
            type: 'string',
            isSortable: true,
        }
    }

    static build(
        sectorMap: RecordMap<SectorModel>,
        cityMap: RecordMap<CityModel>,
        viewEnums: MatchingEnums

    ): Record<keyof MatchingViewModel, Header<MatchingViewModel>> {

        const header = new MatchingHeader();

        return {
            id: header.id,
            needId : header.needId,
            propertyId : header.propertyId,
            contactName: header.getContact(),
            status: header.getStatus(viewEnums.MatchingStatusEnum),
            operationType: header.getOperationType(viewEnums.propertyEnums.OperationTypeEnum),
            priceRangeLabel: header.getPriceRange(viewEnums.propertyEnums.PriceRangeEnum),
            createdAt: header.createdAt,
            cityName: header.getCity(cityMap),
            sectorName: header.getSector(sectorMap),
            propertyType: header.getType(viewEnums.propertyEnums.PropertyTypeEnum),
            propertyCategory: header.getCategory(viewEnums.propertyEnums.PropertyCategoryEnum),
        } as Record<keyof MatchingViewModel, Header<MatchingViewModel>>
    }
}